import { useContext } from "react";
import { AuthContext } from "../../contexts/auth";

export default () => useContext(AuthContext);
